import { useState, ChangeEvent } from 'react';
import { SelectChangeEvent } from '@mui/material';

const useJobForm = () => {
    const [title, setJobTitle] = useState('');
    const [description, setJobDescription] = useState('');
    const [requirements, setJobRequirements] = useState('');
    const [responsibilities, setJobResponsibilities] = useState('');
    const [remote, setRemote] = useState(true);
    const [city, setCity] = useState('');
    const [province, setProvince] = useState('');
    const [country, setCountry] = useState('');
    const [published, setPublished] = useState(true);
    const [currentlyAvailable, setCurrentlyAvailable] = useState(true);
    const [salary, setSalary] = useState('');
    const [selectedAssessment, setSelectedAssessment] = useState('');
    const [jobCategory, setJobCategory] = useState('');
    const [jobType, setJobType] = useState('');
    const [applicationDeadline, setApplicationDeadline] = useState('');


    const handleJobCategoryChange = (event: SelectChangeEvent) => {
        setJobCategory(event.target.value);
    };

    const handleJobTypeChange = (event: SelectChangeEvent) => {
        setJobType(event.target.value);
    };

    const handleCurrentlyAvailableChange = (event: SelectChangeEvent) => {
        const value = event.target.value;
        setCurrentlyAvailable(value === 'currently-available');
    };


    const handleRemoteChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRemote(event.target.checked);
    };

    const handlePublishedChange = (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
        setPublished(event.target.checked);
    };

    return {
        title,
        setJobTitle,
        description,
        setJobDescription,
        requirements,
        setJobRequirements,
        responsibilities,
        setJobResponsibilities,
        remote,
        setRemote,
        city,
        setCity,
        province,
        setProvince,
        country,
        setCountry,
        published,
        setPublished,
        currentlyAvailable,
        setCurrentlyAvailable,
        salary,
        setSalary,
        selectedAssessment,
        setSelectedAssessment,
        jobCategory,
        setJobCategory,
        jobType,
        setJobType,
        applicationDeadline,
        setApplicationDeadline,
        handleJobCategoryChange,
        handleJobTypeChange,
        handleCurrentlyAvailableChange,
        handleRemoteChange,
        handlePublishedChange
    };

};

export default useJobForm;

